import {call} from "redux-saga/effects";
import apiCall from "../utils/apiCall";
import {trackError} from "../../store/log/actions";
import {LogLevel} from "../../store/log/types";

let notFoundKeys: string[] = [];
let lastTrackingId = 0;

export function trackNotFoundLocalizationKey(key: string) {
    if (notFoundKeys.includes(key))
        return;

    notFoundKeys.push(key);
}

export function* addNotFoundLocalizationKeys() {
    if (!notFoundKeys.length || lastTrackingId === notFoundKeys.length)
        return;

    try {
        yield call(apiCall, {
            params: {
                section: "localization",
                method: "addNotFoundKeys",
            },
            data: {
                keys: notFoundKeys.slice(lastTrackingId)
            },
            retryCount: 1,
        });

        lastTrackingId = notFoundKeys.length;
    }
    catch (error) {
        trackError({
            logLevel: LogLevel.Warn,
            category: "addNotFoundLocalizationKeys",
            message: "Failed to add not found localization keys",
            error
        })
    }
}